import { Link, useLocation } from "react-router-dom";
import { Lightbulb, Building2 } from "lucide-react";

const TABS = [
  { to: "/gruender", label: "Ich gründe", icon: Lightbulb },
  { to: "/business", label: "Bestehendes Business", icon: Building2 },
];

export function AudienceToggle() {
  const { pathname } = useLocation();
  return (
    <div data-testid="audience-toggle" className="inline-flex p-1 rounded-full bg-slate-100 border border-slate-200">
      {TABS.map((t) => {
        const active = pathname === t.to;
        const Icon = t.icon;
        return (
          <Link
            key={t.to}
            to={t.to}
            data-testid={`audience-tab-${t.to === "/gruender" ? "gruender" : "business"}`}
            className={`inline-flex items-center gap-1.5 px-4 py-2 text-sm font-semibold rounded-full transition-colors ${
              active ? "bg-white text-slate-900 shadow-sm" : "text-slate-500 hover:text-slate-700"
            }`}
          >
            <Icon className="h-4 w-4" style={{ color: active ? "var(--brand-solid)" : "currentColor" }} />
            {t.label}
          </Link>
        );
      })}
    </div>
  );
}

export default AudienceToggle;
